import { useDevice } from "@/store/useDevice";
import RequestsMobile from "./mobile/requests/RequestsMobile";
import Requests from "./Requests.page";

const LayoutRequests = () => {
  const { isMobile } = useDevice();

  if (isMobile) {
    return <RequestsMobile />;
  }

  return <Requests />;
};

export default LayoutRequests;
